import React, { createContext, useState, useEffect, useContext } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [tenantId, setTenantId] = useState(localStorage.getItem('hs_tenant_id') || 'tenant_001_demo');
  const [token, setToken] = useState(localStorage.getItem('hs_jwt_token') || null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (token) {
      localStorage.setItem('hs_jwt_token', token);
    } else {
      localStorage.removeItem('hs_jwt_token');
    }
  }, [token]);

  useEffect(() => {
    if (tenantId) {
      localStorage.setItem('hs_tenant_id', tenantId);
    }
  }, [tenantId]);

  useEffect(() => {
    const initAuth = async () => {
      if (token && !user) {
        setLoading(true);
        try {
          const res = await api.get('/auth/me');
          setUser(res.data.user);
        } catch (err) {
          console.error('Failed to restore session', err);
          logout();
        } finally {
          setLoading(false);
        }
      }
    };
    initAuth();
  }, [token, user]);

  const login = async (email, password, selectedTenantId = 'tenant_001_demo') => {
    setLoading(true);
    try {
      const res = await api.post('/auth/login', {
        email,
        password,
        tenantId: selectedTenantId
      });

      const { token: newToken, user: userData } = res.data;
      setToken(newToken);
      setUser(userData);
      setTenantId(userData.tenantId);
      return userData;
    } catch (err) {
      console.error('Login failed', err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem('hs_jwt_token');
  };

  return (
    <AuthContext.Provider value={{ user, token, tenantId, setTenantId, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
